import { render, staticRenderFns } from "./IShard.vue?vue&type=template&id=b293cd44&"
import script from "./IShard.vue?vue&type=script&lang=ts&"
export * from "./IShard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports